
import { PerformanceInidicatorHelper } from './../../helpers/performanceInidicator.helper';
import { LanguageService } from './../../services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { EntityPerformanceOverviewDto } from './../../models/entityPerformanceOverviewDto';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PerformanceIndicator } from '../../models/performanceIndicator';
@Component({
    selector: 'app-kpi-tooltip',
    templateUrl: './kpi-tooltip.component.html',
    styleUrls: ['./kpi-tooltip.component.scss'],
    standalone: false
})
export class KPITooltipComponent implements OnInit {
  isVisible:boolean;
  hasBeenClicked: boolean;
  @Input() kpiInformation: EntityPerformanceOverviewDto;
  targetId: string;
  shouldShow = false;
  @Output() componentChanged = new EventEmitter();
  swapColors = false;

  constructor(
    private readonly translateService: TranslateService,
    private readonly languageService: LanguageService
  ) {}


  ngOnInit() {
    const currentLanguage = this.translateService.currentLang;
    if (this.languageService.getSwapColorsLanguageCodes().indexOf(currentLanguage) > -1) {
      this.swapColors = true;
    }
    this.kpiInformation.performanceIndicators.forEach(element => {
      if(element.targetValue){
        const calculatedPercent = (element.actualValue / element.targetValue) * 100;
        element.calculatedValue = Math.floor(calculatedPercent);
      }
    });
  }

  onHoverableContainerClick() {
    this.hasBeenClicked = true;
    this.shouldShow = !this.shouldShow;
    this.isVisible = this.shouldShow;
    if(!this.shouldShow){
      this.hasBeenClicked = false;
    }
    this.componentChanged.emit();
  }

  onHoverableContainerMouseEnter() {
    if (!this.hasBeenClicked) {
      this.isVisible = true;
    }
    this.componentChanged.emit();
  }

  onHoverableContainerMouseLeave() {
    if (this.hasBeenClicked && this.shouldShow) {
      this.isVisible = true;
    } else {
      this.isVisible = false;
      this.shouldShow = false;
    }
    this.componentChanged.emit();
  }

  onHidingTooltip() {
    this.hasBeenClicked = false;
    this.componentChanged.emit();
  }

  getPerformanceColor(pi: PerformanceIndicator) {
    return PerformanceInidicatorHelper.getPerformanceColor(pi,this.swapColors);
  }
}
